import { DeleteAccountCompleteRoute } from '@/App/AppRoutes/DeleteAccountCompleteRoute';
import { DeleteAccountRoute } from '@/App/AppRoutes/DeleteAccountRoute';
import { DeleteAccountTokenInvalidRoute } from '@/App/AppRoutes/DeleteAccountTokenInvalidRoute';
import { ForgotPasswordCompleteRoute } from '@/App/AppRoutes/ForgotPasswordCompleteRoute';
import { ForgotPasswordRoute } from '@/App/AppRoutes/ForgotPasswordRoute';
import { HomeLayoutRouteBase } from '@/App/AppRoutes/HomeLayoutRouteBase';
import { RegisterCompleteRoute } from '@/App/AppRoutes/RegisterCompleteRoute';
import { ResetPasswordCompleteRoute } from '@/App/AppRoutes/ResetPasswordCompleteRoute';
import { ResetPasswordRoute } from '@/App/AppRoutes/ResetPasswordRoute';
import { ResetPasswordTokenInvalidRoute } from '@/App/AppRoutes/ResetPasswordTokenInvalidRoute';
import { SignUpRoute } from '@/App/AppRoutes/SignUpRoute';
import { TokenInvalidRoute } from '@/App/AppRoutes/TokenInvalidRoute';
import { TokenValidRoute } from '@/App/AppRoutes/TokenValidRoute';
import type { AppRouteConfig } from '@/App/AppRoutes/types';

import { HomeRoute } from './HomeRoute';
import { LoginRoute } from './LoginRoute';

export const HomeLayoutRoute: AppRouteConfig = {
  ...HomeLayoutRouteBase,
  children: [
    HomeRoute,
    LoginRoute,
    SignUpRoute,
    ForgotPasswordRoute,
    RegisterCompleteRoute,
    TokenValidRoute,
    TokenInvalidRoute,
    ForgotPasswordCompleteRoute,
    ResetPasswordCompleteRoute,
    ResetPasswordTokenInvalidRoute,
    ResetPasswordRoute,
    DeleteAccountCompleteRoute,
    DeleteAccountTokenInvalidRoute,
    DeleteAccountRoute,
  ],
};
